export interface IStatisticsFiltersDto {
    carrierIds?: string[];
    tripDefinitionIds?: string[];
}
